import React from "react";
import { FaqAccordionGroupProps } from "../../components/FaqAccordionGroup/FaqAccordionGroup";
import { LinkButton, LinkButtonProps } from "../../components/LinkButton";
import { List } from "../../components/List";
import { Paragraph, ParagraphProps } from "../../components/Paragraph";
import { ProcessSteps, ProcessStepsProps } from "../../components/ProcessSteps";
import { Responsibilities, ResponsibilitiesProps } from "../../components/Responsibilities";
import { SeoHeaderProps } from "../../components/SeoHeader";
import { ServiceCataloguePageWrapper } from "../../components/ServiceCataloguePageWrapper";
import { GenericListProps } from "../../types/GenericListType";

export interface BuildersTemporarySupplyPageProps {
  seo?: SeoHeaderProps;
  pageTitle: string;
  paragraphs?: ParagraphProps[];
  lists?: GenericListProps[];
  responsibilities?: ResponsibilitiesProps[];
  processes?: ProcessStepsProps[];
  applyButton?: LinkButtonProps;
  faqs?: FaqAccordionGroupProps;
}

export const BuildersTemporarySupplyPage: React.FC<BuildersTemporarySupplyPageProps> = ({
  seo,
  pageTitle,
  paragraphs,
  lists,
  responsibilities,
  processes,
  applyButton,
  faqs,
}) => {
  return (
    <ServiceCataloguePageWrapper seo={seo} title={pageTitle} faqs={faqs}>
      {paragraphs && paragraphs[0] && <Paragraph {...paragraphs[0]} />}
      {lists && lists[0] && <List {...lists[0]} />}
      {responsibilities && responsibilities[0] && <Responsibilities {...responsibilities[0]} />}
      {processes && processes[0] && <ProcessSteps {...processes[0]} />}
      {applyButton && <LinkButton {...applyButton} />}
    </ServiceCataloguePageWrapper>
  );
};
